module.exports = __webpack_public_path__ + "img/title3.faa27b74.png";